module.exports = __webpack_public_path__ + "static/media/33.a0633594.jpg";